module.exports = __webpack_public_path__ + "files/4081b100ce12105dfe8914062ba57356.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/foods-2.png
// module id = 1610
// module chunks = 60